'use strict';


import { TilesPluginCore } from './TilesPluginCore';
import { Compass } from '../../compass/compass';
import { GSAPAnimationMixer, TRoot } from '../../../../settings';
import { Lerp } from '../../../projectTime/Lerp';
import gsap from 'gsap';

export class PanoramaCompassPlugin extends TilesPluginCore{
	constructor (panorama) {
		super('PanoramaCompassPlugin');
	
		this.panorama = panorama;
		const awaitBottomNavBar = setInterval(() => {
			if (document.querySelector('.bottom__nav-bar')) {
				clearInterval(awaitBottomNavBar);
				this.compass = new Compass(document.querySelector('.bottom__nav-bar'),'panoramaCompass',this.panorama.camera,this.panorama.controls);
				this.compass.element.addClass('air-mode__compass');
				this.compass.addClickHandler(this.#clickHandler.bind(this));
				this.update();
				const orbitCompass = Compass.getScope('orbit');
				if (orbitCompass) {
					orbitCompass.element.addClass('hidden');
				}
			}
		},1000);
		
	}
	
	#clickHandler() {
		const theta = new Lerp(this.compass.spherical.theta,config.threejs.compass.correction);
		const phi = new Lerp(this.compass.spherical.phi,Math.PI / 2);
		
		const progress = {
			value: 0
		};
		
		gsap.to(progress,{
			value: 1,
			ease: GSAPAnimationMixer.ease,
			duration: GSAPAnimationMixer.duration,
			onUpdate: () => {
				this.panorama.controls.setAzimuthAngle(theta.lerp(progress.value));
				this.panorama.controls.setPolarAngle(phi.lerp(progress.value));
			}
		});
	}
	
	update () {
		this.compass?.rotate();
	}
	
	disable () {
		this.dispose();
	}
	
	enable () {
		if (this.compass) {
			this.compass.element.appendTo(document.querySelector('.bottom__nav-bar'));
			const orbitCompass = Compass.getScope('orbit');
			if (orbitCompass) {
				orbitCompass.element.addClass('hidden');
			}
		}
	}
	
	dispose () {
		if (this.compass) {
			this.compass.element.DOMElement.remove();
			const orbitCompass = Compass.getScope('orbit');
			if (orbitCompass) {
				orbitCompass.element.removeClass('hidden');
			}
		}
	}
	
}
